import * as React from "react";

import Modal, { ModalSize } from "../../../../misc/components/modal";
import { MiscCorrectionForm } from './MiscCorrectionForm';
import { MiscCorrection } from '../../../Request/DcfRequestReducer';
import { WizardState, WizardActionTypes } from '../WizardTypings';
import { useWizard } from '../../../Hooks/UseWizard';
import { CorrectionPreviewModal } from '../../CorrectionPreviewModal';
import { Form } from "informed";

export interface MiscCorrectionWizardProps {
    isVisible: boolean;
    onClose: () => void;
    onComplete: (correction: MiscCorrection) => void;
    correction: MiscCorrection;
}

export const MiscCorrectionWizard = ({ isVisible, onClose, onComplete, correction }: MiscCorrectionWizardProps): JSX.Element => {
    correction = correction || { fromDetails: null, toDetails: null };

    const { currentState, dispatch } = useWizard();

    const [miscCorrection, setMiscCorrection] = React.useState<MiscCorrection>(correction);

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <Form initialValues={{ originalEntry: miscCorrection.fromDetails, newEntry: miscCorrection.toDetails }}>
                    <MiscCorrectionForm
                        originalEntry={miscCorrection.fromDetails}
                        newEntry={miscCorrection.toDetails}
                        onNext={(form): void => {
                            setMiscCorrection({ fromDetails: form.originalEntry, toDetails: form.newEntry });
                            dispatch(WizardActionTypes.Next)
                        }}
                    />
                </Form>
            );
            break;
        case 1:
            page = (
                <CorrectionPreviewModal
                    corrections={[]}
                    miscCorrection={miscCorrection}
                    onNext={(): void => { dispatch(WizardActionTypes.Reset); onComplete(miscCorrection) }}
                    onPrev={(): void => dispatch(WizardActionTypes.Previous)}
                />
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal show={isVisible} header="Request Other Correction" size={ModalSize.Large} closeModalHandler={onClose}>
            {page}
        </Modal>
    );
};
